import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import useSubUrl from './useSubUrl';

export const STEPS = [
	{ label: 'Select Plan', path: '/subscription-plan' },
	{ label: 'Billing Details', path: '/checkout' },
	{ label: 'Make Payment', path: '/payment' },
];

// These pages exist both as bare paths (brand-new user, no workspace yet)
// and as /user/:suburl/<path> (existing user, e.g. resubscribing) — see
// router/index.js. Strip a leading /user/:suburl so step matching works on
// either, and re-add it (from whichever suburl is actually current) when
// navigating between steps, so the Stepper never drops the subdomain from
// the URL.
export const useStepper = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const { suburl: suburlParam } = useParams();
	const suburl = useSubUrl();
	const activeSuburl = suburlParam || suburl;

	const bareCurrentPath = suburlParam
		? location.pathname.replace(`/user/${suburlParam}`, '')
		: location.pathname;

	const currentStep = useMemo(() => {
		return STEPS.findIndex((step) => step.path === bareCurrentPath);
	}, [bareCurrentPath]);

	const goToStep = (index) => {
		const target = STEPS[index];
		const params = new URLSearchParams(location.search);
		params.set('step', target.label.toLowerCase().replace(/\s+/g, '-'));
		const basePath = activeSuburl ? `/user/${activeSuburl}${target.path}` : target.path;
		navigate(`${basePath}?${params.toString()}`);
	};

	return {
		steps: STEPS,
		currentStep,
		goToStep,
	};
};
